











































































import Vue from "vue";

export interface MonatseinnahmenVerschiebenEvent {
  sourceStudio: string;
  targetStudio: string;
  betrag: number;
}

export default Vue.extend({
  name: "MonatsuebersichtContextMenu",
  data() {
    return {
      // Einstellungen für Popover-Dialog
      popoverTitle: "",
      showPopover: false,

      // Daten
      sourceStudio: "",
      targetStudio: "",
      betrag: 0,
      betragEingabe: "",

      // Validierung
      studioHatGeringereEinnahmen: false,
      betragFehler: false,
      betragWarnung: false,
    };
  },
  methods: {
    show(sourceStudio: string, targetStudio: string, betrag: number) {
      this.sourceStudio = sourceStudio;
      this.targetStudio = targetStudio;
      this.betrag = betrag;
      this.betragEingabe = this.formatiereBetrag(this.betrag);
      this.studioHatGeringereEinnahmen = betrag == 0;
      this.betragFehler = this.betragWarnung = false;
      console.log('Formatierte Betrag: ' + this.betragEingabe);

      this.popoverTitle = `Betrag von ${sourceStudio} nach ${targetStudio} verschieben`;

      this.showPopover = true;
    },

    formatiereBetrag(betrag?: number) {
      return this.betrag ? Math.floor(this.betrag) + ',' + (""+Math.floor((this.betrag * 100) % 100)).padEnd(2, '0') : "";
    },

    updateBetrag(rest?: any) {
      const neueBetrag = this.betragEingabe;
      console.log(neueBetrag);
      console.log(rest);
      const punktPos = neueBetrag.indexOf('.');
      const kommaPos = neueBetrag.indexOf(',');
      let vorkomma = neueBetrag, nachkomma = "00";
      if (kommaPos < punktPos) {
        vorkomma = neueBetrag.substring(0, punktPos).replaceAll(',', '');
        nachkomma = neueBetrag.substring(punktPos + 1);
      } else if (kommaPos >= 0) {
        vorkomma = neueBetrag.substring(0, kommaPos).replaceAll('.', '');
        nachkomma = neueBetrag.substring(kommaPos + 1);
      }
      if (nachkomma.length == 1) {
        nachkomma += "0";
      }
      console.log("Berechne Betrag aus " + vorkomma + " und " + nachkomma);
      let fraction = Number.parseInt(nachkomma) / 100;
      while (fraction > 1) { fraction /= 10; }
      this.betrag = Number.parseInt(vorkomma) + fraction;
      this.betragFehler = nachkomma.length != 2 || (vorkomma.length <= 1 && this.betrag != 0) || this.betrag < 0;
      this.betragWarnung = this.betrag < 50;
    },

    // Behandeln von Eingabemasken/Dialog für
    // Neuanlage/Bearbeitung/Löschung
    popoverYesSave() {

      this.showPopover = false;

      this.$emit("update", {
        sourceStudio: this.sourceStudio,
        targetStudio: this.targetStudio,
        betrag: this.betrag,
      } as MonatseinnahmenVerschiebenEvent);
    },
    popoverNoAbort() {
      this.showPopover = false;
    },
  },
});
